import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import { dateFormat } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";
import { isVigente } from "../cronogramaUtil";

/** Lista dos períodos (Cronograma Data) da turma. */
export default function CronogramaDataTable({ listCronogramaData, isLoading, onSelect, onEdit, onDelete, onNovo }) {
  const renderConteudo = () => {
    if (isLoading) {
      return (
        <Box py={6}>
          <Loading description="Carregando períodos..." />
        </Box>
      );
    }
    if (listCronogramaData.length === 0) {
      return (
        <Box
          sx={{
            py: 6,
            textAlign: "center",
            color: "text.secondary",
            border: 1,
            borderStyle: "dashed",
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <EventNoteOutlinedIcon fontSize="large" />
          <Typography variant="body2" mt={1}>
            Nenhum período cadastrado para esta turma.
          </Typography>
        </Box>
      );
    }
    return (
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" aria-label="Períodos do cronograma">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell>Início</TableCell>
              <TableCell>Fim</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell align="right" sx={{ width: 140 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {listCronogramaData.map((periodo) => (
              <TableRow key={periodo.codigo} hover onClick={() => onSelect(periodo)} sx={{ cursor: "pointer" }}>
                <TableCell>{dateFormat(periodo.dataInicio)}</TableCell>
                <TableCell>{periodo.dataFim ? dateFormat(periodo.dataFim) : "Sem data fim"}</TableCell>
                <TableCell>
                  {isVigente(periodo) && <Chip size="small" color="success" variant="outlined" label="Vigente" />}
                </TableCell>
                <TableCell align="right" onClick={(event) => event.stopPropagation()}>
                  <Tooltip title="Editar período">
                    <IconButton size="small" onClick={() => onEdit(periodo)}>
                      <EditOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Remover período">
                    <IconButton size="small" onClick={() => onDelete(periodo)}>
                      <DeleteOutlineIcon fontSize="small" color="error" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Abrir cronograma">
                    <IconButton size="small" onClick={() => onSelect(periodo)}>
                      <ChevronRightIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} mb={2}>
        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            Períodos do cronograma
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Cada período tem seu próprio quadro de aulas. Selecione um para ver ou editar.
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={onNovo} sx={{ flexShrink: 0 }}>
          Novo Período
        </Button>
      </Stack>
      {renderConteudo()}
    </Box>
  );
}
